import React, { forwardRef } from 'react';
import { Input, type InputProps, InputRef } from 'antd';
import {
  RegistrationFormItem,
  RegistrationFormItemProps
} from '@components/Patients/Registration/RegistrationFormItem';
import { sanitiseValueFromAngleBrackets } from 'vl-common/src/utils';
import i18n from 'vl-common/src/lib/i18n';

const t = i18n.getFixedT(null, 'main');

export const PrefNameFormItem = forwardRef<InputRef, RegistrationFormItemProps & { inputProps?: InputProps }>(
  ({ inputProps, ...props }, ref) => (
    <RegistrationFormItem
      normalize={sanitiseValueFromAngleBrackets}
      name="pref_name"
      label={t('Preferred Name')}
      {...props}
    >
      <Input type="text" data-testid="prefname" ref={ref} {...inputProps} />
    </RegistrationFormItem>
  )
);
